import React from "react";
import {Link} from "react-scroll"

export default function TeamPageBanner() {
  return (
    <div className="header-content py-24 dark:bg-content flex items-center justify-center dark:text-white">
      <div className="grid md:grid-cols-2 gap-10 w-11/12 lg:w-9/12">
        <div className="flex flex-col justify-center">
          <h1 className="text-4xl lg:text-6xl font-bold">
            Discover our core team members{" "}
            <span className="text-sky-800 dark:text-sky-500">
              {" "}
              GDSC UIT
            </span>
          </h1>
          <p className="mt-3 text-xl">
          </p>
          <Link
            to="coreteamsection"
            smooth="true"
            spy="true"
            data-aos="fade-right"
            data-aos-delay="300"
            className="mt-5 w-36 bg-sky-100 dark:bg-sky-500 dark:text-white text-sky-800 transition-all px-10 py-4 rounded-full hover:bg-sky-200"
          >
            Explore
          </Link>
        </div>
        <div>
          <a
            className="flex items-center justify-center"
          >
            <div >
             
              <div className="flex items-center w-full p-5 ">
             


                    <div id="Core-Team-Page-Circle">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="300px"
                        height="300px"
                        viewBox="0 0 300 300"
                        enableBackground="new 0 0 300 300"
                        xmlSpace="preserve"
                      >
                        <defs>
                          <path
                            id="circlePath"
                            d=" M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "
                          />
                        </defs>
                        <circle cx={150} cy={100} r={75} fill="none" />
                        <g>
                          <use xlinkHref="#circlePath" fill="none" />
                          <text fill="#0EA5E9">
                            <textPath xlinkHref="#circlePath">
                              CORE TEAM GDSC UIT{" "}
                            </textPath>
                          </text>
                        </g>
                      </svg>
                    </div>
                  </div>


                  
              </div>
          </a>
        </div>
      </div>
    </div>
  );
}
